import { render, staticRenderFns } from "./VwRename.vue?vue&type=template&id=2162b410&lang=pug&"
import script from "./VwRename.vue?vue&type=script&lang=ts&"
export * from "./VwRename.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VwRename.vue"
export default component.exports